import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateService } from "../../api/apiServices";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث خدمة
 */
export function useUpdateService() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateServiceMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateService(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["services"] });
            navigate('/services');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update service");
        },
    });

    return {
        updateServiceMutate,
        isPending,
    };
}